module.exports = __webpack_public_path__ + "img/eagleEyeLogo.d7b83b01.png";